import {
  ACCOMMODATION_SERVICES_SECTOR,
  ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR,
  ARTS_ENTERTAINMENT_SECTOR,
  CONSTRUCTION_SECTOR,
  EDUCATIONAL_SERVICES_SECTOR,
  FINANCE_AND_INSURANCE_SECTOR,
  FISHING_AND_HUNTING_SECTOR,
  HEALTH_CARE_SECTOR,
  INFORMATION_SECTOR,
  MANAGEMENT_OF_COMPANIES_SECTOR,
  MANUFACTURING_SECTOR,
  MINING_QUARRYING_OIL_AND_GAS_SECTOR,
  OTHER_SERVICES_SECTOR,
  PUBLIC_ADMINISTRATION_SECTOR,
  REAL_ESTATE_SECTOR,
  RETAIL_TRADE_SECTOR,
  SCIENTIFIC_SERVICES_SECTOR,
  TRANSPORTATION_AND_WAREHOUSING_SECTOR,
  UTILITIES_SECTOR,
  WHOLESALE_TRADE_SECTOR,
} from '../industrySectorOptions';

export const SECTOR_OPTIONS_ES = [
  { value: FISHING_AND_HUNTING_SECTOR, label: 'Agricultura, Silvicultura, Pesca y Caza' },
  { value: MINING_QUARRYING_OIL_AND_GAS_SECTOR, label: 'Minería, Explotación de Canteras y Extracción de Petróleo y Gas' },
  { value: UTILITIES_SECTOR, label: 'Servicios Públicos' },
  { value: CONSTRUCTION_SECTOR, label: 'Construcción' },
  { value: MANUFACTURING_SECTOR, label: 'Manufactura' },
  { value: WHOLESALE_TRADE_SECTOR, label: 'Comercio Mayorista' },
  { value: RETAIL_TRADE_SECTOR, label: 'Comercio Minorista' },
  { value: TRANSPORTATION_AND_WAREHOUSING_SECTOR, label: 'Transporte y Almacenamiento' },
  { value: INFORMATION_SECTOR, label: 'Información' },
  { value: FINANCE_AND_INSURANCE_SECTOR, label: 'Finanzas y Seguros' },
  { value: REAL_ESTATE_SECTOR, label: 'Bienes Raíces, Alquiler y Arrendamiento' },
  { value: SCIENTIFIC_SERVICES_SECTOR, label: 'Servicios Profesionales, Científicos y Técnicos' },
  { value: MANAGEMENT_OF_COMPANIES_SECTOR, label: 'Gestión de Empresas y Corporaciones' },
  {
    value: ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR,
    label: 'Servicios Administrativos, de Apoyo y Gestión de Residuos y Remediación Ambiental',
  },
  { value: EDUCATIONAL_SERVICES_SECTOR, label: 'Servicios Educativos' },
  { value: HEALTH_CARE_SECTOR, label: 'Atención Sanitaria y Asistencia Social' },
  { value: ARTS_ENTERTAINMENT_SECTOR, label: 'Arte, Entretenimiento y Recreación' },
  { value: ACCOMMODATION_SERVICES_SECTOR, label: 'Alojamiento y Servicios de Alimentación' },
  { value: OTHER_SERVICES_SECTOR, label: 'Otros Servicios (excepto la Administración Pública)' },
  { value: PUBLIC_ADMINISTRATION_SECTOR, label: 'Administración Pública' },
];

